import { Link, useNavigate, useLocation } from 'react-router-dom';
import * as rdHelper from 'helpers/Uri';
import { isNil } from 'lodash';

export const useRDNavigate = () => {
    const { search } = useLocation();

    const processSearchPara = (search: string) => {
        if (isNil(search) || search == "")
            return search;

        let newSearch = "";

        let searchArray = search.replace("?", "").split("&");
        for (let i = 0; i < searchArray.length; i++) {
            let searchItem = searchArray[i];
            //alert(searchItem)
            if (searchItem != "") {
                let searchItemArray = searchItem.split("=");
                if (searchItemArray.length >= 1) {
                    if (searchItemArray[0].toLowerCase() == "evar25") {
                        newSearch += (isNil(newSearch) || newSearch == "") ? "?" + searchItemArray[0] + "=" + searchItemArray[1] :
                            "&" + searchItemArray[0] + "=" + searchItemArray[1];
                    }
                }
            }
        }
        //alert(newSearch)
        return newSearch;
    }

    ///rdPara does not need pass "?"
    const getNewNavUrl = (url: string, rdParam?: string): string => {
        let newUrl = "";
        if (url == "-1") {
            return newUrl;
        }
        else {
            let newSearch = processSearchPara(search);
            if (!isNil(newSearch) && newSearch != "") {
                if (!isNil(rdParam) && rdParam != "") {
                    newUrl = `${url}${newSearch}&${rdParam}`;
                }
                else {
                    newUrl = `${url}${newSearch}`;
                }
            }
            else {
                if (!isNil(rdParam) && rdParam != "") {
                    newUrl = `${url}?${rdParam}`;
                }
                else {
                    newUrl = `${url}`;
                }
            }
        }
        return newUrl;
    }

    return getNewNavUrl;
}